import OverviewConfig from './overview/OverviewConfig';
import CalendarConfig from './calendar/CalendarConfig';
import ObjectItemsConfig from './objectitems/ObjectItemsConfig';
import RequestsConfig from './requests/RequestsConfig';
import ReportsConfig from './reports/ReportsConfig';
import EmployeesConfig from './employees/EmployeesConfig';
import TasksConfig from './tasks/TasksConfig';
import { Navigate } from 'react-router-dom';
import i18next from 'i18next';
import enGB from '@locales/timelite/enGB';
import deAT from '@locales/timelite/deAT';
import settingsConfig from 'app/configs/settingsConfig';

i18next.addResourceBundle('enGB', 'timelite', enGB);
i18next.addResourceBundle('deAT', 'timelite', deAT);

const TimeLiteConfigs = [
	OverviewConfig,
	CalendarConfig,
	ObjectItemsConfig,
	RequestsConfig,
	ReportsConfig,
	EmployeesConfig,
	TasksConfig,
	{
		routes: [
			{
				path: '/tl',
				exact: true,
				element: <Navigate to="/tl/overview" />,
			}
		]
	}
];

export default TimeLiteConfigs;
